import moment from 'moment'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

function validatorFactory (dateFormat, getOther, otherLabel, comparison, messageCode) {
	return function (val) {
		if (_.isEmpty(val)) {
			return
		}

		var other = getOther()

		if (_.isEmpty(other)) {
			return
		}

		var valMoment = moment(val, dateFormat)

		return valMoment[comparison](other)
			? null : i18n.get(messageCode, otherLabel)
	}
}

/*
 * Returns a function for use as a marked-field validator, which validates that the
 * date is after the date in the given date-input view.
 */
function afterDateInput (dateFormat, otherDateInput, otherLabel) {
	return validatorFactory(dateFormat, otherDateInput.getMoment.bind(otherDateInput), otherLabel, 'isSameOrAfter', 'common.error.onOrAfter')
}

/*
 * Returns a function for use as a marked-field validator, which validates that the
 * date is before the date in the given date-input view.
 */
function beforeDateInput (dateFormat, otherDateInput, otherLabel) {
	return validatorFactory(dateFormat, otherDateInput.getMoment.bind(otherDateInput), otherLabel, 'isBefore', 'common.error.before')
}

export { afterDateInput }
